import { captureMessage } from '@sentry/react';

const DEDUPE_WINDOW_MS = 5000;
const recentlyReported = new Map();

export const getBuildId = () => {
  const script = Array.from(document.scripts || []).find((s) => /\/static\/js\/main\.[^/]+\.js/.test(s.src || ''));
  const match = script?.src?.match(/main\.([a-z0-9]+)\.js/i);
  return match ? match[1] : null;
};

export const reportClientEvent = (event, details = {}) => {
  const key = `${event}|${window.location.pathname}${window.location.search}`;
  const lastSentAt = recentlyReported.get(key);
  const now = Date.now();
  if (lastSentAt !== undefined && now - lastSentAt < DEDUPE_WINDOW_MS) {
    return Promise.resolve();
  }
  recentlyReported.set(key, now);

  const payload = {
    event,
    details,
    url: window.location.href,
    referrer: document.referrer || null,
    userAgent: navigator.userAgent,
    buildId: getBuildId(),
    timestamp: new Date().toISOString(),
  };
  try {
    captureMessage(`client:${event}`, { level: 'warning', extra: payload });
  } catch (_) {}
  return fetch('/api/v1/client-log', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
    credentials: 'same-origin',
  }).catch(() => {});
};
